<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <h1 class="text-center lifedi-color">ตารางกิจกรรม</h1>
  <br />
  <div class="row mt-3 mb-3" *ngIf="rows?.length === 0">
    <h4 class="text-center w-100">
      ยังไม่มี workshop
    </h4>
  </div>
  <div *ngIf="rows?.length > 0">
    <div class="row" *ngIf="rows">
      <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let item of rows">
        <mat-card [routerLink]="item.WORKSHOP_ID">

          <img [src]="item.WORKSHOP_PIC" class="workshopPic" />
          <img *ngIf="item.WORKSHOP_QTY_LEARNERS <= item.COUNT_REGIS" class="workshopPicFull" src="assets/full.png" />

          <div style="display: flex; justify-content: flex-end">
            <mat-card-subtitle class="numRegis">
              <div class="text-center">
                {{ item.COUNT_REGIS }}/{{ item.WORKSHOP_QTY_LEARNERS }}
              </div>
            </mat-card-subtitle>
          </div>

          <mat-card-title class="text-center">
            <b class="cut-text">{{ item.WORKSHOP_NAME }}</b>
          </mat-card-title>

          <!-- <mat-card-content>
            <div innerHtml="{{ item.WORKSHOP_DETAIL }}" class="cut-text"></div>
          </mat-card-content> -->

          <mat-card-subtitle>
            <span class="text-center">
              {{ item.WORKSHOP_DATE[0].dateTime[0] | date }} ( {{ item.WORKSHOP_DATE | lengthOfArray }} วัน )
            </span>
          </mat-card-subtitle>

          <mat-card-footer>
            <div class="d-flex align-items-center" style="padding: 10px 0 0;">
              <div class="col-2">
                <img [src]="item.WORKSHOP_COACH_PIC" class="coachPic" />
              </div>
              <div class="col-10 text-left" style="line-height: 1.8;">
                {{ item.WORKSHOP_COACH }}
              </div>
            </div>
            <div class="col-12 text-right mb-2">
              <b style="color: #de5c8e;line-height: 1.8;">
                <span *ngIf="item.WORKSHOP_PRICE === 0">ฟรี</span>
                <span *ngIf="item.WORKSHOP_PRICE > 0">{{ item.WORKSHOP_PRICE | number}} บาท</span>
              </b>
            </div>
          </mat-card-footer>
        </mat-card>

        <mat-spinner *ngIf="!rows" class="spinner-center"></mat-spinner>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center p-2" *ngIf="rows">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
    </ngb-pagination>
  </div>
</div>

<div [ngClass]="rows?.length > 0 ? '' : 'footer'">
  <lifedi-footer *ngIf="rows"></lifedi-footer>
</div>